'use client';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import Image from 'next/image';
import ProcessVector from '@/public/ProcessVector.png';
// import Blur from '@/public/blur.png';

const ProcessCard = ({ number, title, description }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div
      ref={ref}
      className={`relative w-full h-72 p-6 rounded-2xl bg-[#0C1015]
        border border-gray-600 overflow-hidden md:max-w-[18.5rem] shrink-0
        ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
        transition-all duration-700 ease-out group`}
    >
      {/* Background vector image */}
      <Image
        src={ProcessVector}
        alt="Process Vector Background"
        width={280}
        height={280}
        className="absolute inset-0 object-cover opacity-25"
      />

      {/* Background blur image */}
      {/* <Image
        src={Blur}
        alt="Blur Background"
        width={280}
        height={280}
        className="absolute inset-0 object-cover opacity-15"
      /> */}
      {/* Glowing corner borders */}
      <div className="absolute inset-0 pointer-events-none">
        {/* -- TOP RIGHT corner -- */}
        <div className="absolute top-0 right-0 w-16 h-16">
          {/* Horizontal fade line */}
          <div
            className="
              absolute top-0 right-0
              w-16 h-[2px]
              bg-gradient-to-r from-transparent to-[#1FBCCB]
              opacity-0 group-hover:opacity-100
              transition-opacity duration-300
            "
          />
          {/* Vertical fade line */}
          <div
            className="
              absolute top-0 right-0
              h-16 w-[2px]
              bg-gradient-to-b from-transparent to-[#1FBCCB]
              opacity-0 group-hover:opacity-100
              transition-opacity duration-300
            "
          />
        </div>

        {/* -- BOTTOM LEFT corner -- */}
        <div className="absolute bottom-0 left-0 w-16 h-16">
          {/* Horizontal fade line */}
          <div
            className="
              absolute bottom-0 left-0
              w-16 h-[2px]
              bg-gradient-to-r from-[#1FBCCB] to-transparent
              opacity-0 group-hover:opacity-100
              transition-opacity duration-300
            "
          />
          {/* Vertical fade line */}
          <div
            className="
              absolute bottom-0 left-0
              h-16 w-[2px]
              bg-gradient-to-b from-[#1FBCCB] to-transparent
              opacity-0 group-hover:opacity-100
              transition-opacity duration-300
            "
          />
        </div>
      </div>

      {/* Card content */}
      <div className="relative z-10 flex flex-col items-center mt-10">
        {/* Glowing number icon */}
        <div className="relative w-12 h-12 mb-4">
          <div className="absolute inset-0 rounded-xl opacity-20 blur-lg" />
          <div className="relative flex items-center justify-center w-full h-full bg-[#0C1015] rounded-xl border border-[#1FBCCB40]">
            {/* Top-right inner glow */}
            <div
              className="absolute top-1 right-1 w-6 h-6 opacity-0 group-hover:opacity-50 transition-opacity duration-300"
              style={{
                background:
                  'radial-gradient(circle at top right, rgba(255,255,255) 20%, #1FBCCB 40%, transparent 50%)',
                filter: 'blur(4px)',
              }}
            />

            {/* Bottom-left inner glow */}
            <div
              className="absolute bottom-0.5 left-1 w-6 h-6 opacity-0 group-hover:opacity-50 transition-opacity duration-300"
              style={{
                background:
                  'radial-gradient(circle at bottom left, rgba(255,255,255) 20%, #1FBCCB 40%, transparent 50%)',
                filter: 'blur(4px)',
              }}
            />
            <div className="relative z-10 flex items-center justify-center h-full">
              <span className={`text-white font-bold text-xl`}>{number}</span>
            </div>
          </div>
        </div>

        {/* Text content */}
        <h3 className="bg-gradient-to-b from-white via-white/60 to-white/10 text-transparent bg-clip-text text-xl font-semibold mb-3 text-center">
          {title}
        </h3>
        <p className="text-gray-400 text-xs leading-relaxed text-center font-light line-clamp-4">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ProcessCard;
